import { getCurrentInstance, onMounted, ref } from "vue";

export interface CacheProps {
    savedData?: any;
}

export function usePopupManagerCache<T extends CacheProps, T2>(
    /** Props компонента */
    props: T, 
    /** Callback промиса на получение кэшируемых данных*/
    cb: () => Promise<T2>
) {
    const savedDataPromise = ref<Promise<any>>();
    let callCount = 0; 

    const fetchData: () => Promise<T2> = async () => {
        if (props.savedData) {
            return new Promise((resolve) => {
                resolve(props.savedData);
            });
        } else {
            if (!savedDataPromise.value) {
                if (callCount > 0) {
                    console.error('Caching promise created more than 1 time');
                }

                callCount += 1;
                savedDataPromise.value = cb();
            }

            return savedDataPromise.value;
        }
    }

    

    onMounted(() => {
        const instance = getCurrentInstance();
        if (!instance?.exposed?.fetchData) {
            console.error('fetchData is not exposed via defineExpose. Caching will not be performed.', instance?.exposed);
        }
    })

    return {
        savedDataPromise,
        fetchData,
    }
}